package ai.flowstorm.studio.ui.data

import ai.flowstorm.common.setProperty
import ai.flowstorm.common.ui.EntityTable
import ai.flowstorm.studio.model.ProfileRecord
import ai.flowstorm.studio.model.User
import ai.flowstorm.studio.resources.space.ProfileRecordResource
import io.kvision.i18n.tr
import io.kvision.modal.ModalSize
import io.kvision.state.ObservableList
import io.kvision.tabulator.ColumnDefinition
import io.kvision.tabulator.Layout
import io.kvision.tabulator.TabulatorOptions
import io.kvision.utils.obj

class ProfileRecordTable(user: User, entities: ObservableList<ProfileRecord>) : EntityTable<ProfileRecord>(
    caption = "Profile Record",
    model = ProfileRecordResource(user, entities),
    tabulatorOptions = TabulatorOptions(
        layout = Layout.FITCOLUMNS,
        columns = listOf(
            ColumnDefinition(tr("Time"), ProfileRecord::timestampAsText.name, width = "13%"),
            ColumnDefinition(tr("Content"), ProfileRecord::content.name, width = "30%"),
            ColumnDefinition(tr("Reliability (%)"), ProfileRecord::reliabilityAsText.name, width = "5%"),
            ColumnDefinition(tr("Language"), ProfileRecord::language.name, width = "5%"),
            ColumnDefinition(tr("Search Rank"), ProfileRecord::rankScore.name, width = "10%"),
            ColumnDefinition(tr("Persona"), ProfileRecord::personaName.name, width = "10%"),
            ColumnDefinition(tr("Categories"), ProfileRecord::categoriesAsText.name, width = "15%"),
            ColumnDefinition(tr("Tags"), ProfileRecord::tagsAsText.name, width = "15%"),
            ColumnDefinition(tr("Embedding Model"), ProfileRecord::embeddingModel.name, width = "10%")
        ),
    ),
    dataExtractor = {
        obj {
            setProperty(this, it::timestampAsText)
            setProperty(this, it::content)
            setProperty(this, it::reliabilityAsText)
            setProperty(this, it::language)
            setProperty(this, it::rankScore)
            setProperty(this, it::personaName)
            setProperty(this, it::categoriesAsText)
            setProperty(this, it::tagsAsText)
            setProperty(this, it::embeddingModel)
        }
    },
    entityComponentFactory = { ProfileRecordWrapper(ProfileRecordResource(user, entities)) },
    deleteEnabled = false,
    saveEnabled = false,
    modalSize = ModalSize.XLARGE,
    hideHeader = true,
)